/**
 * We'll load jQuery, jQuery-UI and the Bootstrap jQuery plugin which provides
 * support for JavaScript based Bootstrap features such as modals and tabs.
 */
window.$ = jQuery = require('jquery'); // eslint-disable-line no-multi-assign, no-undef

require('bootstrap-sass/assets/javascripts/bootstrap/dropdown');
require('bootstrap-sass/assets/javascripts/bootstrap/modal');
require('bootstrap-sass/assets/javascripts/bootstrap/tab');
require('bootstrap-sass/assets/javascripts/bootstrap/tooltip');
require('bootstrap-sass/assets/javascripts/bootstrap/transition');

require('bootstrap-3-typeahead');


/**
 * Add moment.js to have something like Carbon for the frontend.
 * This is used for date formatting and presentation.
 */
const moment = require('moment');

moment.locale('de');

window.moment = moment;


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': window.KwIntern.csrfToken,
  'X-Requested-With': 'XMLHttpRequest',
};


/**
 * Next, we add SweetAlert to create fancier alerts. We use version 2
 * since the first one has been neglected for quite a while.
 */
window.swal = require('sweetalert2');


/**
 * Lastly, we add some misc. helper libraries.
 */
window._ = require('lodash');
window.Color = require('color');
window.marked = require('marked');
window.printElement = require('./utils/print').default;


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js